import Swal from "sweetalert2";
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';
export default {
    name: 'Courses',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        await this.CheckLoginStatus();
        await this.GetAllFarmes();
        await this.GetAllGroups();
        await this.GetAllPesticidesCompanies();
        await this.GetAllPestsCompanies();



        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

   
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: ' الأفات  ',
            ScreenTitleSingle: ' أفة',
            ScreenTitleSingleAl: 'الأفة ',

            Info: [],
            Statistics: [],
            AvailablePalms: [],

            AddDialog: false,

            SelectedItem: '',
            ByFarmesId: '',
            ByGroupsId: '',


            ruleForm: {
                Id: '',
                FarmesId: '',
                GroupsId: '',
                PalmsId: '',
                PestsCompaniesId: '',
                PestsId: '',
                PesticidesCompaniesId: '',
                PesticidesId: '',
                PestsDate: '',
                Quantity: '',
                Price: '',
                Results: '',
            },
            rules: {
                PestsCompaniesId: this.$helper.Required(),
                PestsId: this.$helper.Required(),
                PesticidesCompaniesId: this.$helper.Required(),
                PesticidesId: this.$helper.Required(),
                PestsDate: this.$helper.Required(),
                Quantity: this.$helper.Required(),
                Price: this.$helper.Required(),
            },

        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.ByFarmesId > 0)
                this.GetAllGroups(this.ByFarmesId);

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetPalmsPests(this.pageNo, this.pageSize, this.Search, this.ByFarmesId, this.ByGroupsId)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        GetAvailablePalms() {

            this.AvailablePalms = [];
            this.$blockUI.Start();
            this.$http.GetNotAvailablePalms(this.ruleForm.FarmesId, this.ruleForm.GroupsId)
                .then(response => {
                    this.$blockUI.Stop();
                    this.AvailablePalms = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },


        

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.ruleForm.Id = Number(0);

                    if (!this.ruleForm.Quantity) {
                        this.ruleForm.Quantity = Number(0);
                    } else {
                        this.ruleForm.Quantity = Number(this.ruleForm.Quantity);
                    }

                    if (!this.ruleForm.Price) {
                        this.ruleForm.Price = Number(0);
                    } else {
                        this.ruleForm.Price = Number(this.ruleForm.Price);
                    }
                    
                    if (!this.ruleForm.PestsDate)
                        this.ruleForm.PestsDate = null;


                    this.$blockUI.Start();
                    this.$http.AddPalmsPests(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإظافة', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الإظافة', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        
        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.FarmesId = item.farmesId;
            this.GetAllGroups(item.farmesId);
            
            this.ruleForm.PestsId = item.pestsId;
            this.ruleForm.PestsCompaniesId = item.pestsCompaniesId;
            this.ruleForm.PesticidesId = item.pesticidesId;
            this.ruleForm.PesticidesCompaniesId = item.pesticidesCompaniesId;
            this.ruleForm.Quantity = item.quantity;
            this.ruleForm.PestsDate = item.pestsDate;
            this.ruleForm.Price = item.price;
            this.ruleForm.Results = item.results;
            this.ruleForm.GroupsId = item.groupsId;
            this.GetAvailablePalms();
            this.GetAllPesticides(item.pesticidesCompaniesId);
            this.GetAllPests(item.PestsCompaniesId);

        },

        submitEditForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {

                    if (!this.ruleForm.Quantity) {
                        this.ruleForm.Quantity = Number(0);
                    } else {
                        this.ruleForm.Quantity = Number(this.ruleForm.Quantity);
                    }

                    if (!this.ruleForm.Price) {
                        this.ruleForm.Price = Number(0);
                    } else {
                        this.ruleForm.Price = Number(this.ruleForm.Price);
                    }

                    if (!this.ruleForm.PestsDate)
                        this.ruleForm.PestsDate = null;

                    this.$blockUI.Start();
                    this.$http.EditPalmsPests(this.ruleForm)
                        .then(response => {
                            this.$blockUI.Stop();
                            this.GetInfo();
                            this.ClearForm(this.ruleForm);
                            this.$helper.DestroyElemntById('Close');
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية التعديل', 'حدت خطاء غير متوقع');
                            }
                        });


                } else {
                    this.$helper.showSwal('warning');
                    return false;
                }
            });
        },

        Delete(Id) {
            Swal.fire({
                title: 'تأكيد العملية ',
                text: ' هـل انت متأكد من عملية الحذف  ؟',
                icon: 'question',
                customClass: {
                    confirmButton: 'btn btn-primary'
                },
                buttonsStyling: false,
                confirmButtonText: `تأكيد العملية`,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$blockUI.Start();
                    this.$http.DeletePalmsPests(Id)
                        .then((response) => {
                            this.$blockUI.Stop();
                            this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                            this.GetInfo();
                        })
                        .catch((err) => {
                            this.$blockUI.Stop();
                            if (err.response && err.response.data) {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', err.response.data);
                            } else {
                                this.$helper.ShowMessage('error', 'خطاء بعملية الحذف', 'حدت خطاء غير متوقع');
                            }
                        });
                    return;
                }
            });
        },


        
        


    }
}
